import { fetchAuthSession, signOut } from 'aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';
import { computed, ComputedRef, onUnmounted, ref, Ref } from 'vue';

export default function () {
  const authStatus: Ref<'authenticated' | 'unauthenticated'> = ref('unauthenticated');
  const signedIn: ComputedRef<boolean> = computed(() => authStatus.value === 'authenticated');

  const refreshAuthStatus = async (): Promise<void> => {
    try {
      const session = await fetchAuthSession();
      authStatus.value = session.tokens ? 'authenticated' : 'unauthenticated';
    } catch {
      authStatus.value = 'unauthenticated';
    }
  };

  const logout = async (): Promise<void> => {
    await signOut();
  };

  const stopListening = Hub.listen('auth', ({ payload }) => {
    if (payload.event === 'signedIn' || payload.event === 'signedOut') {
      void refreshAuthStatus();
    }
  });

  onUnmounted(stopListening);
  void refreshAuthStatus();

  return {
    logout,
    signedIn,
  };
}
